module.exports = __webpack_public_path__ + "374cd71a46013bce7e602ff1a6314b85.gif";